import React, { useEffect, useState } from "react";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import productsDb from "../../../../mocks/db/products.db";
import Table, { TBody, Td, TFoot, Th, THead, Tr } from "../../../../components/ui/Table";
import Icon from "../../../../components/icon/Icon";
import { CardBody, CardHeader, CardHeaderChild, CardTitle } from "../../../../components/ui/Card";
import { TableCardFooterTemplate } from "../../../../templates/common/TableParts.template";
import TableSkeletonLoader from "../../../../components/loader/skeleton/tableSkeletonLoader";
import AddMachineModel from "../../../../components/admin/home/addMachineModel";
import Button from "../../../../components/ui/Button";
import { useNavigate } from "react-router-dom";

const defaultData = [productsDb[0], productsDb[1], productsDb[2]];

const columnHelper = createColumnHelper();

const TablePartial = ({ isLoading, machineData, pagination, setPageSize, setPageIndex, handleResetPagination }) => {
  const navigate = useNavigate();
  const [sorting, setSorting] = React.useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [editMachineInfo, setEditMachineInfo] = useState({});

  useEffect(() => {
    if (!modalStatus) setEditMachineInfo({});
  }, [modalStatus]);

  const columns = [
    columnHelper.accessor("Subscription Code", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.SubscriptionCode || "-"}</div>,
      header: "Subscription Code",
      footer: "Subscription Code",
    }),
    columnHelper.accessor("Description", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.Description || "-"}</div>,
      header: "Description",
      footer: "Description",
    }),
    columnHelper.accessor("Start Date", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.StartDate || "-"}</div>,
      header: "Start Date",
      footer: "Start Date",
    }),
    columnHelper.accessor("End Date", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.EndDate || "-"}</div>,
      header: "End Date",
      footer: "End Date",
    }),
    columnHelper.accessor("Monthly Costs", {
      cell: (info) => <div className="text-sm text-center">{info?.row?.original?.MonthlyCosts || "-"}</div>,
      header: "Monthly Costs",
      footer: "Monthly Costs",
    }),
    columnHelper.accessor("Action", {
      cell: (info) => (
        <div className="text-sm flex text-center  justify-center">
          <div
            className="text-[#0EA5E9] cursor-pointer"
            onClick={() => {
              // setEditMachineInfo(info?.row?.original);
              // setModalStatus(true);
              // navigate({
              //   pathname: `/admin/edit-machine/${info?.row?.original.AssetId}`,
              //   state: { editMachineInfo: info?.row?.original },
              // });
              navigate(`/admin/edit-machine/${info?.row?.original.AssetId}`, {
                state: { editMachineInfo: info?.row?.original },
              });
            }}
          >
            Edit
          </div>
        </div>
      ),
      header: "Action",
      footer: "Action",
    }),
  ];

  const handleCloseMachinePopUp = () => {
    setModalStatus(false);
  };

  const table = useReactTable({
    data: machineData,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    // debugTable: true,
  });

  return (
    <>
      <CardHeader>
        <CardHeaderChild>
          <CardTitle>Active Subscriptions</CardTitle>
        </CardHeaderChild>
      </CardHeader>

      {/* <div className="m-[14px] text-end">
        <Button variant="solid" onClick={() => navigate(`/admin/add-machine`)}>
          Add Machine
        </Button>
      </div> */}
      <CardBody className="overflow-auto">
        <Table className="table-fixed max-md:min-w-[70rem]">
          <THead>
            {table.getHeaderGroups().map((headerGroup) => (
              <Tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <Th key={header?.id} isColumnBorder={false} className="text-left">
                    {header?.isPlaceholder ? null : (
                      <div
                        key={header.id}
                        aria-hidden="true"
                        {...{
                          className: header.column.getCanSort()
                            ? "cursor-pointer select-none flex items-center justify-center  text-center"
                            : "",
                          onClick: header.column.getToggleSortingHandler(),
                        }}
                      >
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {{
                          asc: <Icon icon="HeroChevronUp" className="ltr:ml-1.5 rtl:mr-1.5" />,
                          desc: <Icon icon="HeroChevronDown" className="ltr:ml-1.5 rtl:mr-1.5" />,
                        }[header.column.getIsSorted()] ?? null}
                      </div>
                    )}
                  </Th>
                ))}
              </Tr>
            ))}
          </THead>
          <TBody>
            {!isLoading ? (
              Number(pagination?.totalRecords) <= 0 ? (
                <Tr>
                  <Td className="text-center py-[100px] font-normal text-[30px]" colspan="11">
                    No Record Found
                  </Td>
                </Tr>
              ) : (
                table.getRowModel().rows.map((row) => (
                  <Tr key={row.id}>
                    {row.getVisibleCells().map((cell) => (
                      <Td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</Td>
                    ))}
                  </Tr>
                ))
              )
            ) : (
              [...Array(pagination?.showRecords)].map((_, index) => (
                <Tr className="bg-gray-100">
                  <TableSkeletonLoader />
                </Tr>
              ))
            )}
          </TBody>
          {/* <TFoot>
            {table.getFooterGroups().map((footerGroup) => (
              <Tr key={footerGroup.id}>
                {footerGroup.headers.map((header) => (
                  <Th key={header.id} isColumnBorder={false} className="text-left">
                    {header.isPlaceholder ? null : (
                      <div
                        key={header.id}
                        aria-hidden="true"
                        {...{
                          className: header.column.getCanSort()
                            ? "cursor-pointer select-none flex items-center  justify-center"
                            : "",
                          onClick: header.column.getToggleSortingHandler(),
                        }}
                      >
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {{
                          asc: <Icon icon="HeroChevronUp" className="ltr:ml-1.5 rtl:mr-1.5" />,
                          desc: <Icon icon="HeroChevronDown" className="ltr:ml-1.5 rtl:mr-1.5" />,
                        }[header.column.getIsSorted()] ?? null}
                      </div>
                    )}
                  </Th>
                ))}
              </Tr>
            ))}
          </TFoot> */}
        </Table>
      </CardBody>
      {/* <TableCardFooterTemplate
        table={table}
        pagination={pagination}
        setPageSize={setPageSize}
        setPageIndex={setPageIndex}
      /> */}

      {/* Edit Machine Model */}

      <AddMachineModel
        handleResetPagination={handleResetPagination}
        handleCloseMachinePopUp={handleCloseMachinePopUp}
        modalStatus={modalStatus}
        setModalStatus={setModalStatus}
        editMachineInfo={editMachineInfo}
      />
    </>
  );
};

export default TablePartial;
